export const products = [
	{
		id: 1,
		itemName: "fall limited edition sneakers",
		itemDesc:
			"These low-profile sneakers are your perfect casual wear companion. Featuring a durable rubber outer sole, they'll withstand everything the weather can offer.",
		originalPrice: 250.0,
		discount: 50,
		discountedPrice: 125.0,
		inStock: 5,
	},
];
